export default __webpack_public_path__ + "static/media/sheetMetal.6475a7d1.webp";